import { FieldKey } from '../../context/field-keys.js';
import { defaultRound } from '../../shared/round.js';
/**
 * SA7 — Potential Gross Income per Area, ported from `sale-auto-calc-listeners.ts`
 * `calculatePGIPerArea` (~843-885):
 *
 *   potential_gross_rate (PGI per area) = potential_gross_income / net_rentable_area
 *
 * CHARACTERIZATION: pins SA7 raw-divide behavior — bug CE-TBD, do not "fix" without QA sign-off.
 * The legacy doc comment claims "Net Rentable Area is always converted to Square Meters before
 * calculation", but the code divides the RAW NRA with NO area conversion (contrast SA6/VPVR,
 * which does convert). This rule reproduces the raw divide exactly; `formulaVersion` is
 * '1.0.0-as-is' to mark the pinned-bug state.
 *
 * Null semantics (verbatim): PGI null/0 OR NRA null/0 -> write null; non-finite -> write null;
 * otherwise round via `deps.round` (legacy '0.2-2'). The result-UOM write (PGI-per-area UOM :=
 * the NRA UOM value, verbatim copy) is host-owned (T2.7).
 */
export const pgiPerAreaRule = {
  id: 'sale.pgi-per-area.from-pgi-nra',
  inputs: [FieldKey.PotentialGrossIncome, FieldKey.NetRentableArea],
  outputs: [FieldKey.SalePgiPerArea],
  formulaVersion: '1.0.0-as-is',
  run: (ctx, deps) => {
    const round = deps?.round ?? defaultRound;
    const pgi = ctx.get(FieldKey.PotentialGrossIncome);
    const nra = ctx.get(FieldKey.NetRentableArea);
    if (pgi == null || pgi === 0 || nra == null || nra === 0) {
      ctx.set(FieldKey.SalePgiPerArea, null);
      return;
    }
    // CHARACTERIZATION: raw divide — deliberately NO square-meter conversion (see file JSDoc).
    const result = Number(pgi) / Number(nra);
    ctx.set(FieldKey.SalePgiPerArea, Number.isFinite(result) ? round(result, FieldKey.SalePgiPerArea) : null);
  }
};
export const pgiPerAreaRules = [pgiPerAreaRule];
